module.exports = __webpack_public_path__ + "static/media/linkedin.5fedcf81.png";